/* eslint-disable no-nested-ternary */
/* eslint-disable import/prefer-default-export */
import { format } from 'date-fns';

const datasetParams = {
  mainFile: 'Web/Email/reducedData.csv',
  runDetailsFile: 'Web/Email/reducedRunDetails.csv',
  tableName: 'Web_Email',
  mainDateField: 'Date',
  headersRemaps: {
    date: 'Date',
  },
  calculatedMetrics: {
    conversionRate: {
      numerator: 'transactions',
      denominator: 'sessions',
    },
  },
  metrics: {
    Users: {
      fieldName: 'totalUsers',
      displayName: 'Users',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    Sessions: {
      fieldName: 'sessions',
      displayName: 'Sessions',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    Transactions: {
      fieldName: 'transactions',
      displayName: 'Transactions',
      chartFormat: ',',
      format: {
        style: 'decimal',
        maximumFractionDigits: 0,
      },
    },
    ConversionRate: {
      fieldName: 'conversionRate',
      displayName: 'Conversion Rate',
      chartFormat: ',.0%',
      format: {
        style: 'percent',
        maximumFractionDigits: 1,
      },
    },
    Revenues: {
      fieldName: 'totalRevenue',
      displayName: 'Revenues',
      chartFormat: '$~s',
      format: {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
      },
    },
  },
  valuesRemaps: {
    sessionSource: {
      sfmc: 'SFMC',
      wunderkind: 'Wunderkind',
    },
  },
  transformRow: (row) => ({
    ...row,
    Date: format(new Date(row.Date), 'yyyy-MM-dd'),
    Year: format(new Date(row.Date), 'yyyy'),
    YearMonth: format(new Date(row.Date), 'yyyy-MM'),
  }),
  filterDimensions: {
    Park: {
      order: 'asc',
      customOrder: ['SWF', 'APO', 'DCO', 'BGT', 'AIT', 'SWC', 'SPC', 'SWT', 'APT', 'BGW', 'WCW', 'SPL'],
    },
    Date: {
      // order: 'desc',
      sortType: 'alpha',
    },
    Year: {
      // order: 'desc',// Gets overridden by the getFilterValues special case
      sortType: 'alpha',
    },
    YearMonth: {
      // order: 'desc',// Gets overridden by the getFilterValues special case
      sortType: 'alpha',
    },
    sessionSource: {
      order: 'desc',
      customOrder: ['SFMC', 'Wunderkind'],
    },
  },
};

export default datasetParams;
